"use client"
import { Box } from "@chakra-ui/react"
import ForwardRegisterTable from "./components/ForwardRegisterTable/ForwardRegisterTable"

const ForwardRegister = () => {
  return (
    <Box>
        <ForwardRegisterTable />
    </Box>
  )
}

export default ForwardRegister